import { IconSparkles } from '@tabler/icons-react';
import type React from 'react';
import type { ImagePromptModel } from '@/lib/image-prompts';
import { Google } from './google';
import { OpenAI } from './openai';

export type ModelIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

const MODEL_ICONS: Record<ImagePromptModel, ModelIcon> = {
  all: IconSparkles,
  nanobanana: Google,
  gptimage: OpenAI,
};

export function getModelIcon(model: ImagePromptModel): ModelIcon {
  return MODEL_ICONS[model] ?? IconSparkles;
}
